export default {"src":"/_next/static/media/logo-appstore.6f063ff8.svg","height":160,"width":540};